import { ExclamationCircleOutlined } from '@ant-design/icons'
import { DropdownSelect } from '@components/_SiteWide/Form/DropdownSelect'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { EditSaveButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Form, Row, Select, Tag } from 'antd'
import React from 'react'

export function Alternates({ products, selectedProduct, editMode, setEditMode }) {
  if (products.length === 0) return null
  const { scopes } = useSecurityContext()
  const canEdit = scopes.admin?.site_write

  return (
    <>
      <Horizontal
        flex={'none'}
        bg='elevated'
        border='bottom'
        verticalCenter
        justifyContent='space-between'
        className='py-2 px-3'
      >
        <Texto className='pb-1' weight='bold'>
          Alternates
        </Texto>
        {canEdit && (
          <EditSaveButton
            editing={editMode}
            onEdit={() => {
              setEditMode(true)
            }}
          />
        )}
      </Horizontal>
      <Vertical height={'auto'} style={{ backgroundColor: 'var(--bg-1)' }} className='p-3' scroll>
        <AlternatesInput editable={editMode} selectedProduct={selectedProduct} alternates={products.sort()} />
      </Vertical>
    </>
  )
}

function AlternatesInput({ selectedProduct, editable = false, alternates }) {
  if (!editable) {
    if (!selectedProduct.alternate_products || selectedProduct.alternate_products.length === 0) {
      return (
        <Horizontal verticalCenter horizontalCenter flex={1}>
          <ExclamationCircleOutlined className='mr-1 no-alternate-products-icon' />
          <Texto appearance='secondary'>No Alternate Products</Texto>
        </Horizontal>
      )
    }

    return selectedProduct.alternate_products.map((item, i) => (
      <Tag className='alternate-product-tags mb-3' key={i}>
        {item}
      </Tag>
    ))
  }
  return (
    <Form.Item name={'alternate_products'} noStyle>
      <Select
        placeholder={'Please select alternate products'}
        mode='multiple'
        defaultValue={selectedProduct.alternate_products}
        showSearch
        disabled={!editable}
        options={alternates.map((product) => ({ label: product, value: product }))}
        allowClear
      />
    </Form.Item>
  )
}
